import { ProposalImage } from 'src/app/models/proposal-image';
import { FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { UnitOfMeasurement } from 'src/app/models/internal/unit-of-measurement';
import { Constants } from '../constants';
import { PartInfo } from 'src/app/models/partinfo';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
import { ProposalBasicInfoDTO } from 'src/app/models/internal/proposal-basicInfo-dto';
import { QueryPartProposalsSearchDTO } from 'src/app/models/internal/query-partproposals-search-dto';
import { DataService } from 'src/app/services/data.service';
import { LocalstorageService } from '../../services/localstorage.service';
import { UserPermissions } from 'src/app/permissions';
import { StorageSettings } from 'src/app/utils/storage.settings';
import { SourceIdList } from '../../models/internal/SourceIdList';

export default class Helper {
    
    static ShowInvalidFormIndicator(g: FormGroup): boolean {
        return (g.dirty || g.touched) && g.invalid;
    }
    static ShowValidFormIndicator(g: FormGroup): boolean {
        return (g.dirty || g.touched) && g.valid;
    }

    static get = function(obj, key) {
        return key.split('.').reduce(function(o, x) {
            return typeof o == 'undefined' || o === null ? o : o[x];
        }, obj);
    };
    static removeFromArr(array, element) {
        const index = array.indexOf(element);
        array.splice(index, 1);
    }

    static formatDate(unformattedDate: Date) {
        const pipe = new DatePipe('en-US');
        return pipe.transform(unformattedDate, 'MM/dd/yyyy');
    }
    static formatDateTime(unformattedDate: Date) {
        const pipe = new DatePipe('en-US');
        return pipe.transform(unformattedDate, 'MMddyyyy_hmmss');
    }
    static getEffectiveTo(unformattedDate: Date) {
        if (!unformattedDate.toString().startsWith('9')) {
            return Helper.formatDate(unformattedDate);
        } else {
            return 'End of time';
        }
    }

    static getDemandStatusDescription(demandStatusCode: string) {
        switch (demandStatusCode) {
          case 'P': {
              return 'Past';
          }
          case 'C': {
              return 'Current';
          }
          case 'F': {
            return 'Future';
          }
      }
      return 'No Demand';
      }

    static getProposalStatusDescription(statusId: number) {
        let desc = '';
        switch (statusId) {
            case Constants.WORKFLOW_STATUS_NEW: {
                desc = 'New (Draft)';
                break;
            }
            case Constants.WORKFLOW_STATUS_SUBMITTED: {
                desc = 'Submitted';
                break;
            }
            case Constants.WORKFLOW_STATUS_REJECTED: {
                desc = 'Rejected';
                break;
            }
            case Constants.WORKFLOW_STATUS_APPROVED: {
                desc = 'Approved';
                break;
            }

            case Constants.WORKFLOW_STATUS_INCOMPLETE: {
                desc = 'Incomplete';
                break;
            }

            case Constants.WORKFLOW_STATUS_PENDINGVALIDATION: {
                desc = 'PendingValidation';
                break;
            }
        }
        return desc;

    }


    static distinct(value, index, self) {
        return self.indexOf(value) === index;
    }
    static roundto8(x) {
        const roundedNumber = (+Number.parseFloat(x).toFixed(8));
        return roundedNumber;
    }
    static roundto3(x) {
        const roundedNumber = (+Number.parseFloat(x).toFixed(3));
        return roundedNumber;
    }
    static roundto4(x) {
        const roundedNumber = (+Number.parseFloat(x).toFixed(4));
        return roundedNumber;
    }

    static roundto6(x) {
        const roundedNumber = (+Number.parseFloat(x).toFixed(6));
        return roundedNumber;
    }

    static getUnitOfMeansurements() {
        const unitOfMeansurementList: UnitOfMeasurement[] = [];
        const imperial = new UnitOfMeasurement();
        imperial.Id = 1;
        imperial.Name = 'Imperial System(inch, lb)';
        imperial.WeightFactor = 2.204622622;
        imperial.DimensionFactor = 1 / 25.4;
        imperial.WeightUoMName = 'lbs';
        imperial.DimensionUoMName = 'inches';
        unitOfMeansurementList.push(imperial);
        const metric = new UnitOfMeasurement();
        metric.Id = 2;
        metric.Name = 'Metric System(mm, kg)';
        metric.WeightFactor = 0.45359237;
        metric.DimensionFactor = 25.4;
        metric.WeightUoMName = 'kg';
        metric.DimensionUoMName = 'mm';
        unitOfMeansurementList.push(metric);
        return unitOfMeansurementList;
    }

    static getUoMObject(id: number) {
        const allUoM = this.getUnitOfMeansurements();
        return allUoM[id - 1];
    }

    static updateUOMs(
        g: FormGroup,
        name: string,
        isWeight: boolean,
        globalUOM: UnitOfMeasurement
    ) {
        const originalVal = g.controls[name].value;
        const roundFunc = null;
        if (originalVal && globalUOM) {
            if (isWeight) {
                 g.controls[name].setValue(Helper.roundto8(originalVal * globalUOM.WeightFactor));
            } else {
                g.controls[name].setValue(Helper.roundto8(originalVal * globalUOM.DimensionFactor));
            }
        }
    }

    static getPackageTypeDescription(typeId: number) {
        if (typeId === 1) {
            return 'Returnable';
        }
        if (typeId === 2) {
            return 'Expendable';
        }
    }

    //tms-37125 when min dims and weight provided, view screen shows rounded value as 0 so rounding upto  places 
    static calculateDim(dim , uom: UnitOfMeasurement, isWeight = false) {
        if (dim == null) {
            return dim;
        }
        if (Constants.IMPERIAL_UOM_ID === uom.Id) {
           return dim;
         } else {
           if (isWeight) {
               return Helper.roundto6(dim * uom.WeightFactor);
           }
            return Helper.roundto6(dim * uom.DimensionFactor);
         }
       }

       static getSourceTypeToDisplay(data: PartInfo) {
        if (data.SourceTypeDescription === data.ParentSourceTypeDescription) {
            return data.SourceTypeDescription;
        } else {
            return data.ParentSourceTypeDescription + ' (' + data.SourceTypeDescription + ')';
        }
    }

    static resetFormErrors(formErrors: any) {
        for (const field in formErrors) {
            if (field) {
              formErrors[field] = '';
            }
        }
    }

    static removeValidators(form: FormGroup) {
        for (const ctrl in form.controls) {
            form.get(ctrl).clearValidators();
            form.get(ctrl).updateValueAndValidity();
        }
    }

    static ValidatePackageTemplateLevelFields(formValue: FormGroup, formErrors, uom: UnitOfMeasurement) {
        for (const controlName in formErrors) {
            if (controlName) {
                if (controlName.includes('Length') && formValue.controls[controlName].value != null) {
                    const minValue = formValue.controls['IsShippable'].value ? Constants.DimensionsMinLength_Shippable : Constants.DimensionsMinLength_NotShippable;
                    const Min = Helper.calculateDim(minValue, uom);
                    const Max =  Helper.calculateDim(Constants.DimensionsMaxLength, uom);
                    if (formValue.controls[controlName].value > (Max)) {
                        formValue.controls[controlName].setErrors({max: true, maxValue: Max});
                    }
                    if (formValue.controls[controlName].value < (Min)) {
                        formValue.controls[controlName].setErrors({min: true, minValue: Min});
                    }
                }
                if (controlName.includes('Width') && formValue.controls[controlName].value != null) {
                    const minValue = formValue.controls['IsShippable'].value ? Constants.DimesionsMinWidth_Shippable : Constants.DimesionsMinWidth_NotShippable;
                    const Min = Helper.calculateDim(minValue, uom);
                    const Max =  Helper.calculateDim(Constants.DimesionsMaxWidth, uom);
                    if (formValue.controls[controlName].value > (Max)) {
                        formValue.controls[controlName].setErrors({max: true, maxValue: Max});
                    }
                    if (formValue.controls[controlName].value < (Min)) {
                        formValue.controls[controlName].setErrors({min: true, minValue: Min});
                    }
                }
                if (controlName.includes('Height') && formValue.controls[controlName].value != null) {
                    const minValue = formValue.controls['IsShippable'].value ? Constants.DimensionsMinHeight_Shippable : Constants.DimensionsMinHeight_NotShippable;
                    const Min = Helper.calculateDim(minValue, uom);
                    const Max =  Helper.calculateDim(Constants.DimensionsMaxHeight, uom);
                    if (formValue.controls[controlName].value > (Max)) {
                        formValue.controls[controlName].setErrors({max: true, maxValue: Max});
                    }
                    if (formValue.controls[controlName].value < (Min)) {
                        formValue.controls[controlName].setErrors({min: true, minValue: Min});
                    }
                }
                if (controlName.includes('MaxWeight') && formValue.controls[controlName].value != null) {
                    const Min = Helper.calculateDim(Constants.MinAllowedMaxWeight, uom, true);
                    const Max =  Helper.calculateDim(Constants.MaxAllowedMaxWeight, uom, true);
                    if (formValue.controls[controlName].value > (Max)) {
                        formValue.controls[controlName].setErrors({max: true, maxValue: Max});
                    }
                    if (formValue.controls[controlName].value < (Min)) {
                        formValue.controls[controlName].setErrors({min: true, minValue: Min});
                    }
                }
                if (controlName.includes('TareWeight') && formValue.controls[controlName].value != null) {
                    const Min = Helper.calculateDim(Constants.MinTareWeight, uom, true);
                    const Max =  Helper.calculateDim(Constants.MaxTareWeight, uom, true);
                    if (formValue.controls[controlName].value > (Max)) {
                        formValue.controls[controlName].setErrors({max: true, maxValue: Max});
                    }
                    if (formValue.controls[controlName].value < (Min)) {
                        formValue.controls[controlName].setErrors({min: true, minValue: Min});
                    }
                }
                if (controlName.includes('TeslaEquipmentCode') && formValue.controls[controlName].value != null) {
                    const Max = Constants.TeslaCodeEquipmentMaxLength;
                    if (formValue.controls[controlName].value.length > (Max)) {
                        formValue.controls[controlName].setErrors({ maxlength: { requiredLength: Max } });
                    }
                }
            }
        }
        return formValue;
    }

    //tms-37125 show upto 6 decimal places for min dims and weight in update mode
    static convertValueForDisplay(g: FormGroup, controlNames) {
        for (const controlName in controlNames) {
            if (controlName && controlNames[controlName] != null) {
                g.controls[controlName].setValue(Helper.roundto6(g.controls[controlName].value));
            }
        }
    }

    static setValuesInForm ( form: FormGroup, controlNames ) {
        for (const controlName in controlNames) {
            if (Helper.roundto3(controlNames[controlName]) === form.controls[controlName].value && controlNames[controlName] != null) {
                form.controls[controlName].setValue(controlNames[controlName]);
            }
        }
    }

    static getPercentagePackageUtilization(partInfoObj, proposalPackageLevelInfoObj, totalPartsInLevel) {
        const partVolume = Helper.getDimValue(partInfoObj, 'Height') * Helper.getDimValue(partInfoObj, 'Width') *
        Helper.getDimValue(partInfoObj, 'Length');
        const packagelevelVolume =  Helper.getDimValue(proposalPackageLevelInfoObj, 'Height')
                                    * Helper.getDimValue(proposalPackageLevelInfoObj, 'Width')
                                       * Helper.getDimValue(proposalPackageLevelInfoObj, 'Length');
        if (partVolume && packagelevelVolume) {
            // TMS-6542 cap it to 100% if more
            const utilizationPercentage =  Helper.roundto3(((partVolume * totalPartsInLevel) / packagelevelVolume) * 100);
            return Math.min(utilizationPercentage, 100);
        } else {
            return ;
        }
    }

    // Get Required Value from Form Or DTO
    static getDimValue(modelObj, dimname) {
        if (modelObj && modelObj.controls && modelObj.controls[dimname]) {
            return modelObj.controls[dimname].value;
        } else if (modelObj && modelObj.hasOwnProperty(dimname)) {
            return modelObj[dimname];
        } else {
            return 0;
        }
    }

    /**
     * TMS-14255 To check if the proposal is effective.
     * @param proposalBasicInfo 
     * @returns 
     */
    static isActiveProposal(proposalBasicInfo: ProposalBasicInfoDTO) {
        if (!proposalBasicInfo || 
            !proposalBasicInfo.EffectiveFrom ||
            !proposalBasicInfo.EffectiveTo) {
                return false;
        }

        return (Date.parse(proposalBasicInfo.EffectiveFrom.toString()) < Date.now()) && 
            (Date.parse(proposalBasicInfo.EffectiveTo.toString()) >= Date.now());
    }

    /**
     * TMS-14255 To check if there are active proposals with given workflow status.
     * Highlight the latest active proposal with given workflow status if available.
     * @param proposalBasicInfoList 
     * @param workflowStatusId workflow status Id, it's nullable
     * @returns 
     */
    static hasActiveProposal(proposalBasicInfoList: ProposalBasicInfoDTO[], workflowStatusId: number | null) {
        if (!workflowStatusId) {
            return false;
        }
    
        const activeProposals = proposalBasicInfoList.filter(p => this.isActiveProposal(p) &&
                                                            p.WorkflowStatusId === workflowStatusId);
    
        if (activeProposals &&
            activeProposals.length) {
            activeProposals[0].CSSClassName = Constants.WORKFLOW_ACTIVE_PROPOSAL_CSS_STYLE_CLASS;
            return true;
        }

        return false;
    }

    /**
     * TMS-14255 To update the CSS style for proposals.
     * Not to highlight New, Rejected, inactive proposals.
     * Highlight the latest active approved proposal if available.
     * If there is no active approved proposal, highlight the latest submitted proposal if available.
     * @param proposalBasicInfoList 
     * @returns 
     */
    static getCSSClassForProposalList(proposalBasicInfoList: ProposalBasicInfoDTO[]) {
        if (!proposalBasicInfoList || 
            !proposalBasicInfoList.length) {
            return;
        }

        if(!this.hasActiveProposal(proposalBasicInfoList, Constants.WORKFLOW_STATUS_APPROVED)) {
            this.hasActiveProposal(proposalBasicInfoList, Constants.WORKFLOW_STATUS_SUBMITTED);
        }
    }
    
    static isValidIdValue(value: number) : boolean {
        if (value !== null && value !== 0 && value !== undefined) {
            return true;
        }
        return false;
    }

    static isValidStringValue(value: string) : boolean {
        if (value !== null && value.length > 0) {
            return true;
        }
        return false;
    }

    static confirmDeleteAction() {
        return (window.confirm('Are you sure you want to delete this proposal?'));
    }
    //TMS-26081 - Confirm deletion of PE
    static confirmDeletePEAction() {
        return (window.confirm('Are you sure you want to delete the selected assignment(s)?'));
    }

    static fillRejectionInfo(proposalDTO) {
        const rejectionInfo = [];
        // Get Distinct Dates from the Rejection Reasons
        const dates = proposalDTO.PackageInfo.RejectionReason.filter(y => y.Description !== 'Other').map(item => item.CreatedOn).filter((value, index, self) => self.indexOf(value) === index);
        // Categories the reasons based on the createdOn Date (Create Array Object)
        dates.forEach(x => {
          rejectionInfo.push( {Date: x , RejectionReasons:
                proposalDTO.PackageInfo.RejectionReason.filter(y => y.CreatedOn === x && y.Description !== 'Other').map(u => u.Description).join(', ').toString()});
        });
        // If their is a rejection comment add it to the first rejections date
        const count = 0;
        // rejectionInfo.forEach(x => {
        //     if (count === 0 ) {
        //         if (x.RejectionReasons && x.RejectionReasons.length > 0) {
        //             x.RejectionReasons += ', ' + proposalDTO.PackageInfo.RejectionComment;
        //         } else {
        //             x.RejectionReasons += proposalDTO.PackageInfo.RejectionComment;
        //         }
        //         count++;
        //     }
        // });
        return rejectionInfo;
      }

     static getListRejectionComment(rejectionComment) {
        const orderedRejectionCommentList = [];
        if (rejectionComment != null) {
            let rejectionComments = rejectionComment.split('[');
            rejectionComments = rejectionComments.filter(x => x.length != 0);
            rejectionComments.forEach(x => {
                x = x.replace(/[']+/g, '');
                if (x.includes(']')) {
                    x  = '[' + x;
                }
                const loc = x.indexOf(']') === -1 ? 0 : x.indexOf(']') + 1;
                if (x.substring(loc, x.length).trim().length > 0) {
                    orderedRejectionCommentList.push(x);
                }
            });
          }
          return orderedRejectionCommentList;
      }

      static latestRejectionComment(rejectionComment) {
        if (rejectionComment != null && rejectionComment.length !== 0) {
            const temp = rejectionComment.split('[');
            // take first valid element (0th will be "" so take 1st index)
            // let latestRejectionComment = temp[temp.length - 1];
            let latestRejectionComment = temp[0].replace(/[']+/g, '') === '' ? temp[1] : temp[0];
            if (latestRejectionComment.includes(']')) {
                latestRejectionComment = '[' + latestRejectionComment;
            }
            const loc = latestRejectionComment.indexOf(']') === -1 ? 0 : latestRejectionComment.indexOf(']') + 1;
            if (latestRejectionComment.substring(loc, latestRejectionComment.length).replace(/[']+/g, '').trim().length > 0) {
                return latestRejectionComment.replace(/[']+/g, '').trim();
            }
            return '';
        }
    }

    static isNullOrSpaces(str) {
        return str === undefined || str === null || str.match(/^ *$/) !== null;
    }

    static createQueryProposolDTO(partInfo: any): QueryPartProposalsSearchDTO {
        const queryPartProposalsSearchDTO: QueryPartProposalsSearchDTO = new QueryPartProposalsSearchDTO();
        queryPartProposalsSearchDTO.Id = partInfo.PartId;
        queryPartProposalsSearchDTO.PEId = 0;
        queryPartProposalsSearchDTO.PartNumber = partInfo.PartNumber;
        queryPartProposalsSearchDTO.SupplierCode = partInfo.SupplierCode;
        queryPartProposalsSearchDTO.UOMCode = partInfo.POUomCode;
        queryPartProposalsSearchDTO.SourceTypeId = partInfo.SourceTypeId;
        queryPartProposalsSearchDTO.TransportModeId = partInfo.TransportModeId;
        queryPartProposalsSearchDTO.PackageTypeId = partInfo.PackageTypeId;
        return queryPartProposalsSearchDTO;
    }

    /**
     * Add number of days to today's date.
     * @param currentDate: the current date
     * @param days positive: add days, negative: substract days
     * @returns The date of (current date + No of added days)
     */
    static addDays(currentDate: Date, days: number): Date {
        if (currentDate == null ||
            !(currentDate instanceof Date)) {
            return;
        }

        let futureDate = currentDate;
        futureDate.setDate(futureDate.getDate() + days);
        return futureDate;
    }

    /**
     * TMS-15424 Remove ability to backdate proposals
     * Users should not be able to provide an effective start date which is in the past.
     * The earliest Effective start date can be today + 1 day.
     */ 
    static validateEffectiveFromDate(currentEffectiveFromDate: Date, minEffectiveFromDate: Date) : boolean {
        // TMS-17191 Consolidate validation of input date
        if (currentEffectiveFromDate == null ||
            !(currentEffectiveFromDate instanceof Date)) {
            return false;
        }

        if (!minEffectiveFromDate) {
            let currentDate = new Date();
            currentDate.setHours(0,0,0,0);
            minEffectiveFromDate = Helper.addDays(currentDate, 1);
        }

        // validate effective from date
        return currentEffectiveFromDate >= minEffectiveFromDate;
    }

   /*This function basically checks for single or multiple selected parts if there are any 
   existing proposals and returns promise object for all the selected parts.
   */ 
    // static findExistingProposals(searchProposalDto: QueryPartProposalsSearchDTO, dataService: DataService): Promise<any> {
    //     return new Promise((resolve, reject) => {
    //         dataService
    //             .getExisitingProposals(searchProposalDto)
    //             .subscribe((response: any) => {
    //                 let result = {
    //                     partNumber: searchProposalDto.PartNumber,
    //                     proposalFound: false
    //                 };
    //                 if (response != null) {
    //                     if (response.Total > 0) {
    //                         result.proposalFound = true;
    //                         resolve(result);
    //                     }
    //                     else {
    //                         resolve(result);
    //                     }
    //                 }
    //             });
    //     });
    // }

    /* 
    TMS-16560 Function which checks whether user has required Read/Write Permission
    */
    static CheckPermission(localstorageService: LocalstorageService, permissionToCheck: any): boolean {
        let findPermissionNameToCheck = Object.keys(UserPermissions)[Object.values(UserPermissions).indexOf(permissionToCheck)];
        let HasPermission: boolean = false;
        let existingUserPermissions: any = localstorageService.retrieve('Permissions');
        HasPermission = Object.keys(existingUserPermissions).includes(findPermissionNameToCheck);
        return HasPermission;
    }

    /**
     * TMS-16613 Show specific error message for Image size issue in portal
     * @param proposalImages 
     */
    static CheckProposalImagesSize(proposalImages: ProposalImage[]): boolean {
        if (!proposalImages) {
            return true;
        }

        let base64EncodedSize = 0;   // base64-encoded images size     

        for(let i = 0; i < proposalImages.length; i++){
            if (proposalImages[i]) {
                base64EncodedSize += proposalImages[i].UUId.length;
            }
        }

        // the factor of base64 encoding is 1.40
        return base64EncodedSize <= Constants.FILE_UPLOAD_MAX_SIZE * 1.40;
    }

    /**
     * TMS-17419 Errors immediately after logging in. Consolidate user logging validation.
     * @param storageSettings 
     * @returns boolean value to indicate if the employee logs in
     */
    static CheckEmployeeLogin(storageSettings: StorageSettings): boolean {
        return storageSettings.retrieve(Constants.storageSettingKeys.STORAGE_SETTING_LOGGED_IN) &&
                storageSettings.retrieve(Constants.storageSettingKeys.STORAGE_SETTING_WARP_USER_ID);
    }

    /**
     * TMS-17419 Errors immediately after logging in. Consolidate user logging validation.
     * @param storageSettings 
     * @returns boolean value to indicate if the supplier user logs in
     */
    static CheckSupplierLogin(storageSettings: StorageSettings): boolean {
        return storageSettings.retrieve(Constants.storageSettingKeys.STORAGE_SETTING_LOGGED_IN) &&
                storageSettings.retrieve(Constants.storageSettingKeys.STORAGE_SETTING_SUPPLIER_CODE);
    }

    //TMS-20775 Alert window for Adhoc DDE requests
    static confirmAdhocDDERequestAction() {
        return (window.confirm('Are you sure you want to update the status of this due date extension request?'));
    }

    //TMS-21403 Generic function which will return list of ids based on select/unselect checkbox for any incoming dto 
    static onRowSelectedChange(dto: any, SourceIdList: SourceIdList): SourceIdList {
        if (dto.IsSelected == true) {
            SourceIdList.Ids.push(dto.Id);
        }
        else {
            SourceIdList.Ids = SourceIdList.Ids.filter(x => x != dto.Id);
        }
        return SourceIdList;
    }

    static confirmPLTFileDeleteAction() {
        return (window.confirm('Are you sure you want to delete this file?'));
    }

    static confirmPLTSupCodeDeleteAction() {
        return (window.confirm('Are you sure you want to delete this supcode?'));
    }

    //tms-28072 Move downloadAttachments() and b64toBlob() to helper to avoid repetition at component level  
    static downloadAttachments(data, filename, type) {
        var file = Helper.b64toBlob(data, type);
        var a = document.createElement("a"),
            url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0);
        //}
    }

    static b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    static getImageDescription(image: ProposalImage) {
        let type = image.Type;
        let category = image.Category;
        if (type == 1) {
            switch (category) {
                case 1:
                    return `Iso-View`;
                case 2:
                    return `Iso-View (Opposite Side)`;
                default:
                    return 'Additional Images';
            }
        }

        switch (category) {
            case 3:
                return `Primary Level Open Box with Parts & Dunnage`;
            case 4:
                return `Primary Level Iso-View`;
            case 5:
                return `Secondary Level Iso-View`;
            case 6:
                return `Tertiary Level Iso-View`;
            case 7:
                return `Empty Pallet/Container`;
            default:
                return 'Additional Images';
        }
    }
}


